import React from 'react';
import { calculImpactPercentage, returnImpactForRow } from '../../../../functions';

type RowLegendProps = {
  row: { name: string };
  totalImpact: number;
  impactUnit?: string;
};

function RowLegend({
  row,
  totalImpact,
  impactUnit = 'kg éq. CO₂/m²',
}: RowLegendProps) {
  const impactForRow = returnImpactForRow(row);
  return (
    <div className="legend-wrapper">
      <p>{row.name}</p>
      <p style={{ fontWeight: 'bold', textAlign: 'right' }}>
        {calculImpactPercentage(impactForRow, totalImpact)} %
      </p>
      <p style={{ textAlign: 'right' }}>{`${impactForRow.toFixed(
        2
      )}${impactUnit}`}</p>
    </div>
  );
}

export default RowLegend;
